import React from "react";

export default function Counter({ value = 0 }) {
  return <div className="counter">{value}</div>;
}
